import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";
import InfoCard from "../Custome/InfoCard";
import Grid from "@material-ui/core/Grid";
import { API } from "../config/config";
import axios from "axios";
import SearchMarket from "./SearchMarket";
import { Spiner } from "../Spinner/Spinner";

class AllMarket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      infos: [],
      message_error: "",
      loading: false
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    try {
      const getinfo = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        body: {
          order_by_field: "created_at",
          order_by_direction: "ACS"
        },
        url: API + "/api/Ims/GetIms"
      };
      let responseinfo = await axios(getinfo);
      // console.log('market')
      // console.log(responseinfo)
      if (responseinfo.status === 200) {
        // console.log(responseinfo.data.results);
        this.setState({ infos: responseinfo.data.results });
      } else {
        console.log("get-market-error");
        console.log(responseinfo);
        alert(
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
        );
      }
    } catch (err) {
      alert(
        "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      );
    }
    this.setState({ loading: false });
  }
  async searchMarket(e) {
    // console.log(e);
    await this.setState({ infos: e });
  }

  render() {
    const { classes } = this.props;
    const { infos, loading } = this.state;

    return (
      <div className="AllMarket pages">
        {loading && <Spiner />}
        <div
          className={classNames(classes.main, classes.mainRaised) + " page-box"}
        >
          <Grid container className={"home-main-grid"} spacing={2}>
            <SearchMarket get={this.searchMarket.bind(this)} />
          </Grid>
          <Grid item sm={12} md={12}>
            {infos !== undefined && infos.length !== 0
              ? infos.map((info, i) => <InfoCard info={info} key={i} />)
              : !loading && (
                  <p className="dont-post">متاسفانه پستی یافت نشد ...</p>
                )}
          </Grid>
          <Grid item sm={12}>
            <div className="postinfos">
              {infos.length !== 0 && (
                <p className="totalpost">
                  تعداد پست :<span>{infos.length}</span>
                </p>
              )}
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}
export default withStyles(componentsStyle)(AllMarket);
